//Librerias
import * as THREE from "three";

//Proyecto
import Maqueta from "../Maqueta.js";
import Ambiente from "./Skins/Skin_Color/Ambiente.js";
import Mapa from "./Mapa.js";
import Modelo from "./Modelo.js";
import Materiales from "./Skins/Skin_Color/Materiales.js";

export default class Mundo {
  constructor() {
    this.maqueta = new Maqueta();
    this.escena = this.maqueta.escena;
    this.colores = this.maqueta.colores;
    this.recursos = this.maqueta.recursos;
    this.escalaProyecto = this.maqueta.tamanos.escalaProyecto;
    this.posicionProyecto = this.maqueta.tamanos.posicionProyecto;
    this.posicionTerreno = this.maqueta.tamanos.posicionTerreno;
    this.materiales = new Materiales();
    this.mapa = {};
    this.debug = this.maqueta.debug;

    /*this.grupoMapa = new THREE.Group();
    this.grupoVias = new THREE.Group();
    this.grupoAndenes = new THREE.Group();
    this.grupoManzanas = new THREE.Group();
    this.grupoTransitoFijo = new THREE.Group();
    this.grupoTransito = new THREE.Group();
    this.grupoEdificios = new THREE.Group();
    this.grupoEdificiosBajos = new THREE.Group();
    this.grupoArbolesCoord = new THREE.Group();
    this.grupoArboles = new THREE.Group();
    this.grupoArbolesParticulas = new THREE.Group();
    this.grupoVegetacion = new THREE.Group();*/
    this.grupoSpritesTest = new THREE.Group();
    this.grupoSprites = new THREE.Group();
    this.grupoProyectoRay = new THREE.Group();
    this.grupoProyecto = new THREE.Group();
    this.mascarasZonas = new THREE.Group();
    this.mascarasProyecto = new THREE.Group();
    this.mapaCoordenadas = {
      x: -26.091,
      y: 0.01,
      z: -25.393,
      escala: 0.255,
    };

    // Esperar que cargue Recursos
    this.recursos.on("cargado", () => {
      // Setup
      this.crearTerreno();
      //this.crearMapa()
      //this.crearVegetacion();
      this.crearModelos();
      //
      this.crearPersonas();
      this.crearArbustos();
      this.crearArboles();
      this.crearArbolesRelleno();
      //this.crearArbolesTest();
      this.escena.add(this.grupoSprites);
      //
      this.crearMascaras();

      this.ambiente = new Ambiente();
      //Debug
      if (this.debug.active) {
        this.debugColores = this.debug.ui.addFolder("Colores");
        this.debugProyecto = this.debug.ui.addFolder("Proyecto");
        this.debugHelpers = this.debug.ui.addFolder("Helpers");
        this.debugTerreno = this.debug.ui.addFolder("Terreno");
        this.debugMapa = this.debug.ui.addFolder("Mapa");
        this.crearDebug();
      }
    });
    console.log("Mundo creado");
  }

  crearHelper() {
    const axesHelper = new THREE.AxesHelper(2);
    axesHelper.position.y = 0.02;
    this.escena.add(axesHelper);

    //Test Mesh
    this.bolaHelper = new THREE.Mesh(
      new THREE.SphereGeometry(0.075, 16, 16),
      new THREE.MeshStandardMaterial({ color: this.colores.paleta.color3 })
    );
    this.escena.add(this.bolaHelper);

    //Plano helper
    this.planoHelper = new THREE.Mesh(
      new THREE.PlaneGeometry(10, 10, 10, 10),
      new THREE.MeshStandardMaterial({
        color: this.colores.paleta.color3,
        wireframe: true,
      })
    );
    this.planoHelper.position.set(0, 0, 0);
    this.planoHelper.rotation.x = Math.PI * 0.5;
    //this.planoHelper.rotation.z = Math.PI * 0.3;
    this.escena.add(this.planoHelper);

    this.debugHelpers
      .add(this.bolaHelper.position, "x")
      .min(-50)
      .max(50)
      .step(0.01)
      .name("Helper x");
    this.debugHelpers
      .add(this.bolaHelper.position, "y")
      .min(-50)
      .max(50)
      .step(0.01)
      .name("Helper y");
    this.debugHelpers
      .add(this.bolaHelper.position, "z")
      .min(-50)
      .max(50)
      .step(0.01)
      .name("Helper z");

    this.debugHelpers
      .add(this.planoHelper.position, "x")
      .min(-500)
      .max(500)
      .step(1)
      .name("planoH x");
    this.debugHelpers
      .add(this.planoHelper.position, "y")
      .min(-500)
      .max(500)
      .step(1)
      .name("planoH y");
    this.debugHelpers
      .add(this.planoHelper.position, "z")
      .min(-500)
      .max(500)
      .step(1)
      .name("planoH z");

    this.debugHelpers
      .add(this.planoHelper.scale, "x")
      .min(-20)
      .max(20)
      .step(0.1)
      .name("planoH sx");
    this.debugHelpers
      .add(this.planoHelper.scale, "y")
      .min(-20)
      .max(20)
      .step(0.1)
      .name("planoH sy");

    this.debugHelpers
      .add(this.planoHelper.rotation, "z")
      .min(-20)
      .max(20)
      .step(0.05)
      .name("planoH rz");
  }
  crearTerreno() {
    //Satelital
    this.satelital = new THREE.Mesh(
      new THREE.CircleGeometry(15, 32),
      this.materiales.materialesContexto.satelital
    );
    //this.satelital.receiveShadow = true;
    this.satelital.scale.set(10.7, 10.7, 1);

    this.satelital.rotation.x = Math.PI * 0.5;
    this.satelital.rotation.z = -0.8;

    this.satelital.position.set(
      -5, //this.posicionTerreno.x,
      this.posicionTerreno.y - 0.15,
      7 //this.posicionTerreno.z
    );

    this.escena.add(this.satelital);

    //Terreno con elevacion
    this.elevacion = new THREE.Mesh(
      new THREE.PlaneGeometry(325, 325, 60, 60),
      this.materiales.materialesContexto.elevacion
    );
    this.elevacion.rotation.x = -Math.PI * 0.5;
    this.elevacion.rotation.z = Math.PI * -0.5;
    this.elevacion.position.y = -3;
    this.escena.add(this.elevacion);

    //Pasto base

    //this.escena.add(this.pastoBase);
  }
  crearModelos() {
    const modelos = [
      //Torre 1
      {
        modeloRuta: this.recursos.items.modelo_torre_1,
        materialRuta: this.recursos.items.text_torre_1,
        materialRutaAlpha: null,
        nombre: "torre_1",
        rayHotspots: true,
      },
      {
        modeloRuta: this.recursos.items.modelo_torre_1_cubierta,
        materialRuta: this.recursos.items.text_torre_1_cubierta,
        materialRutaAlpha: null,
        nombre: "torre_1_cubierta",
        rayHotspots: true,
      },
      {
        modeloRuta: this.recursos.items.modelo_torre_1_barandas,
        materialRuta: this.recursos.items.text_torre_1_barandas,
        materialRutaAlpha: this.recursos.items.text_torre_1_barandas_alpha,
        nombre: "torre_1_barandas",
      },
      {
        modeloRuta: this.recursos.items.modelo_torre_1_rejilla,
        materialRuta: this.recursos.items.text_torre_1_rejilla,
        materialRutaAlpha: this.recursos.items.text_torre_1_rejilla_alpha,
        nombre: "torre_1_rejilla",
      },

      //Torre 2
      {
        modeloRuta: this.recursos.items.modelo_torre_2,
        materialRuta: this.recursos.items.text_torre_2,
        materialRutaAlpha: null,
        nombre: "torre_2",
        rayHotspots: true,
      },
      
      {
        modeloRuta: this.recursos.items.modelo_torre_2_barandas,
        materialRuta: this.recursos.items.text_torre_2_barandas,
        materialRutaAlpha: null,
        nombre: "torre_2_barandas",
      },
      {
        modeloRuta: this.recursos.items.modelo_torre_2_ventanas,
        materialRuta: this.recursos.items.text_torre_2_ventanas,
        materialRutaAlpha: null,
        nombre: "torre_2_ventanas",
      },
      

      //Contexto

      {
        modeloRuta: this.recursos.items.modelo_comunal,
        materialRuta: this.recursos.items.text_comunal,
        materialRutaAlpha: null,
        nombre: "comunal",
      },
      {
        modeloRuta: this.recursos.items.modelo_urbanismoSauces,
        materialRuta: this.recursos.items.text_urbanismoSauces,
        materialRutaAlpha: null,
        nombre: "urbanismoSauces",
      },
      {
        modeloRuta: this.recursos.items.modelo_cerramientoUrbanismo,
        materialRuta: this.recursos.items.text_cerramientoUrbanismo,
        materialRutaAlpha: this.recursos.items.text_cerramientoUrbanismo_alpha,
        nombre: "cerramientoUrbanismo",
      },
      {
        modeloRuta: this.recursos.items.modelo_cerramientoUrbanismo2,
        materialRuta: this.recursos.items.text_cerramientoUrbanismo2,
        materialRutaAlpha: this.recursos.items.text_cerramientoUrbanismo2_alpha,
        nombre: "cerramientoUrbanismo2",
      },
      {
        modeloRuta: this.recursos.items.modelo_urbanismoGeneral,
        materialRuta: this.recursos.items.text_urbanismoGeneral,
        materialRutaAlpha: null,
        nombre: "urbanismoGeneral",
      },
      {
        modeloRuta: this.recursos.items.modelo_adoquinContexto,
        materialRuta: this.recursos.items.text_adoquinContexto,
        materialRutaAlpha: null,
        nombre: "adoquinContexto",
      },
      {
        modeloRuta: this.recursos.items.modelo_contexto2,
        materialRuta: this.recursos.items.text_contexto2,
        materialRutaAlpha: null,
        nombre: "contexto2",
      },
      {
        modeloRuta: this.recursos.items.modelo_adoquinContexto2,
        materialRuta: this.recursos.items.text_adoquinContexto2,
        materialRutaAlpha: null,
        nombre: "adoquinContexto2",
      },
      {
        modeloRuta: this.recursos.items.modelo_carretera,
        materialRuta: this.recursos.items.text_carretera,
        materialRutaAlpha: null,
        nombre: "carretera",
      },
      {
        modeloRuta: this.recursos.items.modelo_fondoMapa,
        materialRuta: this.recursos.items.text_fondoMapa,
        materialRutaAlpha: null,
        nombre: "fondoMapa",
      },
      {
        modeloRuta: this.recursos.items.modelo_plataforma,
        materialRuta: this.recursos.items.text_plataforma,
        materialRutaAlpha: null,
        nombre: "plataforma",
      },
      {
        modeloRuta: this.recursos.items.modelo_duplicadores,
        materialRuta: this.recursos.items.text_duplicadores,
        materialRutaAlpha: null,
        nombre: "duplicadores",
      },
      {
        modeloRuta: this.recursos.items.modelo_carros,
        materialRuta: this.recursos.items.text_carros,
        materialRutaAlpha: null,
        nombre: "carros",
      },
      {
        modeloRuta: this.recursos.items.modelo_pasto,
        materialRuta: this.recursos.items.text_pasto,
        materialRutaAlpha: null,
        nombre: "pasto",
      },
    ];

    //
    modelos.forEach(
      ({
        modeloRuta,
        materialRuta,
        materialRutaAlpha,
        nombre,
        opacidad,
        rayHotspots,
      }) => {
        if (!modeloRuta) {
          console.log("Error con:", nombre);
        } else {
          this[nombre] = modeloRuta.scene;

          const material = new THREE.MeshStandardMaterial({
            map: materialRuta,
          });

          if (materialRutaAlpha) {
            material.transparent = true;
            material.alphaMap = materialRutaAlpha;
            material.side = THREE.DoubleSide;
          }

          if (opacidad) {
            material.transparent = true;
            material.opacity = 0.4;
            material.side = THREE.DoubleSide;
          }
          this[nombre].traverse((child) => {
            child.material = material;
          });

          if (rayHotspots) {
            this.grupoProyectoRay.add(this[nombre]);
          } else {
            this.grupoProyecto.add(this[nombre]);
          }

          // if (this.debug.active) {
          //   this.debugProyecto.add(this[nombre], "visible").name(`${nombre}`);

          //   this.debugProyecto
          //     .add(this[nombre].position, "y")
          //     .min(-2)
          //     .max(2)
          //     .step(0.01)
          //     .name(`${nombre} Y`);
          // }
        }
      }
    );

    //Crear elementos con linea

    this.edificios_vecinos = new Modelo(
      this.recursos.items.modelo_edificiosVecinos,
      this.materiales.materialesProyecto.edificiosVecinos,
      this.grupoProyecto,
      true,
      false
    );

    /*this.fondoMapa.position.y = -0.05
    this.pastoInterior.position.y = 0.05
    this.carretera.position.y = 0.2*/

    //Vías

    /*this.vias = new Modelo(
      this.recursos.items.vias,
      this.materiales.materialesContexto.vias,
      this.grupoProyecto,
      false,
      false
    )

   this.vias.modelo.visible = false    */

    //Configurar modelos
    this.grupoProyecto.scale.set(
      this.escalaProyecto.x,
      this.escalaProyecto.y,
      this.escalaProyecto.z
    );
    this.grupoProyecto.position.set(
      this.posicionProyecto.x,
      this.posicionProyecto.y,
      this.posicionProyecto.z
    );
    //this.grupoProyecto.rotation.y = -0.9//Math.PI * -0.3;

    this.grupoProyecto.add(this.grupoProyectoRay);
    this.escena.add(this.grupoProyecto);
  }
  crearZonas() {
    this.recursos.items.mascarasZonas.scene.traverse((child) => {
      if (child.type === "Mesh") {
        child.material = this.materiales.materialesProyecto.mascarasZonas;
        child.visible = false;
        child.userData.activo = false;
        console.log(child);
      }
    });

    this.mascarasZonas.add(this.recursos.items.mascarasZonas.scene);

    //escalar
    this.mascarasZonas.scale.set(
      this.escalaProyecto.x,
      this.escalaProyecto.y,
      this.escalaProyecto.z
    );
    this.mascarasZonas.position.set(
      this.posicionProyecto.x,
      this.posicionProyecto.y,
      this.posicionProyecto.z
    );

    this.escena.add(this.mascarasZonas);
  }
  crearMascaras() {
    this.mascarasProyecto.scale.set(
      this.escalaProyecto.x,
      this.escalaProyecto.y,
      this.escalaProyecto.z
    );
    this.mascarasProyecto.position.set(
      this.posicionProyecto.x,
      this.posicionProyecto.y,
      this.posicionProyecto.z
    );
    //this.mascarasProyecto.rotation.y = -0.9;
    this.escena.add(this.mascarasProyecto);
    console.log("Mascaras creadas");
  }
  crearNubes() {
    const geometria = new THREE.SphereGeometry(200, 32, 32),
      texturaNubes = this.recursos.items.textura_nubes;

    texturaNubes.wrapS = THREE.RepeatWrapping;
    texturaNubes.wrapT = THREE.RepeatWrapping;
    texturaNubes.repeat.set(2, 4);

    const materialNubes = new THREE.MeshStandardMaterial({
      fog: false,
      side: THREE.BackSide,
      transparent: true,
      map: texturaNubes,
      alphaMap: texturaNubes,
    });

    const esferaNubes = new THREE.Mesh(geometria, materialNubes);

    // Añadir la malla a la escena
    this.escena.add(esferaNubes);
  }
  crearPersonas() {
    const escala = this.mapaCoordenadas.escala,
      x = this.mapaCoordenadas.x,
      y = this.mapaCoordenadas.y,
      z = this.mapaCoordenadas.z;
    //
    const spriteCapa = this.recursos.items.svg_personas_posicion;
    const pathsSVG = spriteCapa.paths;
    //Geometria custom
    const num = pathsSVG.length;
    for (let i = 0; i < num; i++) {
      const numMat = Math.floor(Math.random() * 5);
      const material = this.materiales.materialesPersonas[numMat];
      const sprite = new THREE.Sprite(material),
        posX = pathsSVG[i].subPaths[0].currentPoint.x * escala + x,
        posZ = pathsSVG[i].subPaths[0].currentPoint.y * escala + z;

      sprite.center = new THREE.Vector2(0.5, 0.0);
      sprite.scale.set(0.15, 0.15, 1);

      sprite.position.x = posX;
      sprite.position.y = y;
      sprite.position.z = posZ;

      this.grupoSprites.add(sprite);
    }
  }
  crearArbustos() {
    const escala = this.mapaCoordenadas.escala,
      x = this.mapaCoordenadas.x,
      y = this.mapaCoordenadas.y,
      z = this.mapaCoordenadas.z;
    //
    const spriteCapa = this.recursos.items.svg_arbustos_posicion;
    const pathsSVG = spriteCapa.paths;
    //Geometria custom
    const num = pathsSVG.length;
    for (let i = 0; i < num; i++) {
      const numMat = Math.floor(Math.random() * 3);
      const material = this.materiales.materialesArbustos[numMat];
      const sprite = new THREE.Sprite(material),
        posX = pathsSVG[i].subPaths[0].currentPoint.x * escala + x,
        posZ = pathsSVG[i].subPaths[0].currentPoint.y * escala + z;

      sprite.center = new THREE.Vector2(0.5, 0.0);
      sprite.scale.set(0.12, 0.12, 1);

      sprite.position.x = posX;
      sprite.position.y = y;
      sprite.position.z = posZ;

      this.grupoSprites.add(sprite);
    }
  }
  crearArboles() {
    const escala = this.mapaCoordenadas.escala,
      x = this.mapaCoordenadas.x,
      y = this.mapaCoordenadas.y,
      z = this.mapaCoordenadas.z;
    //
    const spriteCapa = this.recursos.items.svg_arboles_posicion;
    const pathsSVG = spriteCapa.paths;
    //Geometria custom
    const num = pathsSVG.length;
    for (let i = 0; i < num; i++) {
      const numMat = Math.floor(Math.random() * 4);
      const material = this.materiales.materialesArboles[numMat];
      const sprite = new THREE.Sprite(material),
        posX = pathsSVG[i].subPaths[0].currentPoint.x * escala + x,
        posZ = pathsSVG[i].subPaths[0].currentPoint.y * escala + z;

      sprite.center = new THREE.Vector2(0.5, 0.0);
      sprite.scale.set(0.35, 0.35, 1);

      sprite.position.x = posX;
      sprite.position.y = y;
      sprite.position.z = posZ;

      this.grupoSprites.add(sprite);
    }
  }

  crearArbolesRelleno() {
    const escala = this.mapaCoordenadas.escala,
      x = this.mapaCoordenadas.x,
      y = this.mapaCoordenadas.y,
      z = this.mapaCoordenadas.z;
    //
    const spriteCapa = this.recursos.items.svg_arboles_relleno_posicion;
    const pathsSVG = spriteCapa.paths;
    //Geometria custom
    const num = pathsSVG.length;
    for (let i = 0; i < num; i++) {
      const numMat = Math.floor(Math.random() * 3);
      const material = this.materiales.materialesArbolesRelleno[numMat];
      const sprite = new THREE.Sprite(material),
        posX = pathsSVG[i].subPaths[0].currentPoint.x * escala + x,
        posZ = pathsSVG[i].subPaths[0].currentPoint.y * escala + z;

      sprite.center = new THREE.Vector2(0.5, 0.0);
      sprite.scale.set(0.5, 0.5, 1);

      sprite.position.x = posX;
      sprite.position.y = y;
      sprite.position.z = posZ;

      this.grupoSprites.add(sprite);
    }
  }

  crearArbolesTest() {
    const escala = this.mapaCoordenadas.escala,
      x = this.mapaCoordenadas.x,
      y = this.mapaCoordenadas.y,
      z = this.mapaCoordenadas.z;
    //
    const spriteCapa = this.recursos.items.svg_arbolesTest;
    const pathsSVG = spriteCapa.paths;
    //Geometria custom
    const num = pathsSVG.length;
    for (let i = 0; i < num; i++) {
      const numMat = Math.floor(Math.random() * 4);
      const material = this.materiales.materialesArboles[0];
      const sprite = new THREE.Sprite(material),
        posX = pathsSVG[i].subPaths[0].currentPoint.x * escala + x,
        posZ = pathsSVG[i].subPaths[0].currentPoint.y * escala + z;

      sprite.center = new THREE.Vector2(0.5, 0.0);
      sprite.scale.set(0.35, 0.35, 0.35);

      sprite.position.x = posX;
      sprite.position.y = y;
      sprite.position.z = posZ;
      console.log(sprite);

      this.grupoSprites.add(sprite);
    }
    //
    
    //
  }

  probarSprites() {
    console.log("Sprites");
    this.mapaSprites = new THREE.Mesh(
      new THREE.PlaneGeometry(10, 10, 10, 10),
      new THREE.MeshStandardMaterial({
        color: "purple",
        wireframe: true,
      })
    );
    //this.mapaSprites.receiveShadow = true;
    this.mapaSprites.scale.set(1, 1, 1);

    this.mapaSprites.rotation.x = Math.PI * 0.5;

    this.escena.add(this.mapaSprites);

    //
    const escala = 0.05,
      x = 0,
      y = 2,
      z = 0;

    this.mapaCoordenadas.escala = escala;
    this.mapaCoordenadas.x = x;
    this.mapaCoordenadas.y = y;
    this.mapaCoordenadas.z = z;

    this.escena.add(this.grupoSpritesTest);

    this.grupoSpritesTest.rotation.y = 0;
    this.grupoSpritesTest.rotation.x = Math.PI * 0.5;
    this.grupoSpritesTest.rotation.z = 0;

    this.grupoSpritesTest.position.y = 2;

    //console.log(this.recursos.items);
    //console.log(this.recursos.items.svg_arbolesTest);
    //Geometria custom
    this.mapa.base = new Mapa(
      this.recursos.items.svg_base,
      this.materiales.materialesProyecto.mascarasZonas,
      this.grupoSpritesTest,
      true,
      0.045
    );
    this.grupoSpritesTest.scale.set(escala, escala, escala);
    //this.grupoMapa.add(this.grupoAndenes);
    //
  }
  crearRefSprites() {
    console.log("Ref Sprites");

    this.escena.add(this.grupoSpritesTest);

    this.grupoSpritesTest.rotation.y = 0;
    this.grupoSpritesTest.rotation.x = Math.PI * 0.5;
    this.grupoSpritesTest.rotation.z = 0;

    this.grupoSpritesTest.position.y = 0.1;
    this.grupoSpritesTest.position.set(
      this.mapaCoordenadas.x,
      this.mapaCoordenadas.y,
      this.mapaCoordenadas.z
    );

    this.grupoSpritesTest.scale.set(
      this.mapaCoordenadas.escala,
      this.mapaCoordenadas.escala,
      this.mapaCoordenadas.escala
    );

    this.mapa.base = new Mapa(
      this.recursos.items.svg_base,
      this.materiales.materialesProyecto.mascarasZonas,
      this.grupoSpritesTest,
      true,
      0.045
    );

    this.debugMapa
      .add(this.grupoSpritesTest.position, "x")
      .min(-100)
      .max(100)
      .step(0.001)
      .name("Ref Sprites x");
    this.debugMapa
      .add(this.grupoSpritesTest.position, "y")
      .min(-100)
      .max(100)
      .step(0.001)
      .name("Ref Sprites y");
    this.debugMapa
      .add(this.grupoSpritesTest.position, "z")
      .min(-100)
      .max(100)
      .step(0.001)
      .name("Ref Sprites z");

    this.debugMapa
      .add(this.grupoSpritesTest.scale, "x")
      .min(0.01)
      .max(1)
      .step(0.001)
      .name("Ref Sprites sx");
    this.debugMapa
      .add(this.grupoSpritesTest.scale, "y")
      .min(0.01)
      .max(1)
      .step(0.001)
      .name("Ref Sprites sy");
    this.debugMapa
      .add(this.grupoSpritesTest.scale, "z")
      .min(0.01)
      .max(1)
      .step(0.001)
      .name("Ref Sprites sz");
  }
  crearDebug() {
    //Helper
    this.crearHelper();
    //this.probarSprites();
    //this.crearArbolesTest();
    this.crearRefSprites();
    this.debugProyecto
      .add(this.escalaProyecto, "x")
      .min(0.01)
      .max(0.1)
      .step(0.01)
      .name("Proyecto scale x");
    this.debugProyecto
      .add(this.escalaProyecto, "y")
      .min(0.01)
      .max(0.1)
      .step(0.01)
      .name("Proyecto scale y");
    this.debugProyecto
      .add(this.escalaProyecto, "z")
      .min(0.01)
      .max(0.1)
      .step(0.01)
      .name("Proyecto scale z");

    this.debugMapa
      .add(this.grupoSprites.position, "x")
      .min(-100)
      .max(100)
      .step(0.01)
      .name("Sprites x");
    this.debugMapa
      .add(this.grupoSprites.position, "y")
      .min(-5)
      .max(5)
      .step(0.01)
      .name("Sprites y");
    this.debugMapa
      .add(this.grupoSprites.position, "z")
      .min(-100)
      .max(100)
      .step(0.01)
      .name("Sprites z");

    /*this.debugMapa
        .add(this.grupoMapa.position, "x")
        .min(-100)
        .max(100)
        .step(0.001)
        .name("Mapa x");
      this.debugMapa
        .add(this.grupoMapa.position, "y")
        .min(-100)
        .max(100)
        .step(0.001)
        .name("Mapa y");
      this.debugMapa
        .add(this.grupoMapa.position, "z")
        .min(-100)
        .max(100)
        .step(0.001)
        .name("Mapa z");*/

    this.debugProyecto
      .add(this.mascarasZonas.position, "x")
      .min(-5)
      .max(5)
      .step(0.001)
      .name("Zonas Comunes x");

    this.debugProyecto
      .add(this.mascarasZonas.position, "y")
      .min(-5)
      .max(5)
      .step(0.001)
      .name("Zonas Comunes y");

    this.debugProyecto
      .add(this.mascarasZonas.position, "z")
      .min(-5)
      .max(5)
      .step(0.001)
      .name("Zonas Comunes z");

    this.debugProyecto
      .add(this.mascarasZonas.rotation, "y")
      .min(-15)
      .max(15)
      .step(0.01)
      .name("Zonas Comunes ry");

    //Colores

    this.debugColores
      .addColor(this.colores.coloresMundo, "colorEdificios")
      .onChange(() => {
        this.materiales.materialesProyecto.edificiosVecinos.color.set(
          this.colores.coloresMundo.colorEdificios
        );
      })
      .name("Edificios");

    this.debugColores
      .addColor(this.colores.coloresMundo, "colorTerreno")
      .onChange(() => {
        this.materiales.materialesContexto.elevacion.color.set(
          this.colores.coloresMundo.colorTerreno
        );
        this.materiales.materialesContexto.manzanas.color.set(
          this.colores.coloresMundo.colorTerreno
        );
      })
      .name("Terreno");

    this.debugColores
      .addColor(this.colores.coloresMundo, "colorNubes")
      .onChange(() => {
        this.materiales.materialesContexto.nubes.color.set(
          this.colores.coloresMundo.colorNubes
        );
      })
      .name("Nubes");
    //
    this.debugProyecto
      .add(this.satelital.rotation, "z")
      .min(-20)
      .max(20)
      .step(0.05)
      .name("Satelital rz");

    //
    this.debugProyecto
      .add(this.grupoProyecto.position, "x")
      .min(-10)
      .max(10)
      .step(0.01)
      .name("Proyecto x");
    this.debugProyecto
      .add(this.grupoProyecto.position, "y")
      .min(-10)
      .max(10)
      .step(0.01)
      .name("Proyecto y");
    this.debugProyecto
      .add(this.grupoProyecto.position, "z")
      .min(-10)
      .max(10)
      .step(0.01)
      .name("Proyecto z");

    this.debugProyecto
      .add(this.grupoProyecto.rotation, "y")
      .min(-10)
      .max(10)
      .step(0.01)
      .name("Proyecto Rot y");
  }
}
